







































import { defineComponent, ref } from '@vue/composition-api';
import TtamTargetSummaryItem from '@/components/common/target-summary-item/index.vue';
const name = 'ttam-target-summary';
export default defineComponent({
  name,
  components: {
    TtamTargetSummaryItem,
  },
  props: {
    targetSummaryData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    const isShowAll = ref(false);
    function toggleView() {
      isShowAll.value = !isShowAll.value;
    }
    return {
      name,
      isShowAll,
      toggleView,
    };
  },
});
